import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { TransitionState } from 'gatsby-plugin-transition-link'

import { Container, Section } from 'components/layout'
import { HeadlineHero } from 'components/ui/Typography'

import HeroInlineVideoTitle, { getHighlightWordDelay } from './HeroInlineVideoTitle'
import HeroInlineVideoBody from './HeroInlineVideoBody'
import HeroInlineVideoMedia from './HeroInlineVideoMedia'

import s from './HeroInlineVideoSection.module.scss'
const cn = classNames.bind(s)

const HeroInlineVideoSection = ({ title, subtitle, videoEmbedID, titleHighlight }) => {
  const resolvedVideoEmbedID = (videoEmbedID || '').trim()
  const resolvedTitleHighlight = (titleHighlight || 'audience').trim()
  const [inView, setInView] = useState(false)

  const subtitleDelay = useMemo(() => getHighlightWordDelay(title, resolvedTitleHighlight), [
    title,
    resolvedTitleHighlight,
  ])

  return (
    <Section className={cn('section')} onEnter={() => setInView(true)}>
      <TransitionState>
        {({ transitionStatus } = {}) => {
          const isPageTransitioning = transitionStatus === 'exiting' || transitionStatus === 'exited'

          return (
            <Container className={cn('container')}>
              <div
                className={cn('wrapper', { inView, isPageTransitioning })}
                style={{ '--subtitle-delay': subtitleDelay }}
              >
                <div className={cn('mediaCol')}>
                  <HeroInlineVideoMedia videoEmbedID={resolvedVideoEmbedID} isPageTransitioning={isPageTransitioning} />
                </div>
                <div className={cn('titleCol')}>
                  <HeadlineHero className={cn('title')}>
                    <HeroInlineVideoTitle title={title} titleHighlight={resolvedTitleHighlight} />
                  </HeadlineHero>
                </div>
                <div className={cn('subtitleCol')}>
                  <HeroInlineVideoBody subtitle={subtitle} />
                </div>
              </div>
            </Container>
          )
        }}
      </TransitionState>
    </Section>
  )
}

HeroInlineVideoSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  videoEmbedID: PropTypes.string,
  titleHighlight: PropTypes.string,
}

export default HeroInlineVideoSection
